export default __webpack_public_path__ + "static/media/aws.ff13f770.png";